import { DateTime } from "luxon";

// The hospital and SNF demos' draft weeks: by position in the old list, and the dates they cover.
export const minimalWeekIndexThatIsDraft = 4; //that's usually 3 weeks from the current start of the week.
export const draftWeekPeriod = 6; // 6 weeks from beginning of draft mode are considered draft weeks
export const draftModeAfterCurrentWeek = minimalWeekIndexThatIsDraft - 1; // 3 weeks after the current week are considered draft weeks
export const checkIsDraftMode = (weekIndex: number): boolean => weekIndex >= minimalWeekIndexThatIsDraft;
export const getDraftModeStart = () => {
	const start = DateTime.now().startOf("week").plus({ weeks: draftModeAfterCurrentWeek });
	return start.set({ day: 7 }); //set to sunday
};
export const getDraftModeEnd = () => {
	return getDraftModeStart().plus({ weeks: draftWeekPeriod, days: 6 });
};
